const pageNameKey = "tileForm";

export const tileFormEn = {
  [pageNameKey]: {
    id: "ID",
    title: "Title",
    chooseTileTitle: "Choose a tile title",
    position: "Position",
    chooseTilePosition: "Choose a tile position",
    grid_area: "Grid Area",
    chooseTileGridArea: "Choose a tile grid area: quarter|third|half|full",
    frequency: "Frequency for aggregation",
    time_period_amount: "Time Period Amount",
    chooseTileTimePeriodAmount: "Choose a tile time period amount: 0 - 100",
    time_period_time_unit: "Time Period Time Unit",
    chooseTileTimePeriodTimeUnit:
      "Choose a tile time period time unit: seconds|minutes|hours|days|weeks",
    create: "Create",
    update: "Update",
    cancel: "Cancel",
    checkbox: "Fetch aggregated data for single node",
    gridAreaLabels: {
      quarter: "Quarter",
      third: "Third",
      half: "Half",
      full: "Full",
    },
    frequencyLabels: {
      quarterhourly: "Quarter Hourly",
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
    },
    timePeriodLabels: {
      seconds: "Seconds",
      minutes: "Minutes",
      hours: "Hours",
      days: "Days",
      weeks: "Weeks",
    },
  },
};

export const tileFormPtBr = {
  [pageNameKey]: {
    id: "ID",
    title: "Título",
    chooseTileTitle: "Escolha um título de bloco",
    position: "Posição",
    chooseTilePosition: "Escolha uma posição do bloco",
    grid_area: "Área da grade",
    chooseTileGridArea:
      "Escolha uma área da grade de blocos: quarter|third|half|full",
    frequency: "Frequência de agregação",
    time_period_amount: "Valor do período",
    chooseTileTimePeriodAmount:
      "Escolha um valor de período de tempo do bloco: 0 - 100",
    time_period_time_unit: "Período Unidade de tempo",
    chooseTileTimePeriodTimeUnit:
      "Escolha uma unidade de tempo do período do bloco: segundos|minutos|horas|dias|semanas",
    create: "Criar",
    update: "Atualizar",
    cancel: "Cancelar",
    checkbox: "Buscar dados agregados para um único nó",
    gridAreaLabels: {
      quarter: "trimestre",
      third: "Terceiro",
      half: "Metade",
      full: "Cheio",
    },
    frequencyLabels: {
      quarterhourly: "A cada 15 minutos",
      hourly: "Por hora",
      daily: "Diário",
      weekly: "Semanal",
      monthly: "Mensal",
      yearly: "Anual",
    },
    timePeriodLabels: {
      seconds: "Segundos",
      minutes: "Minutos",
      hours: "Horas",
      days: "Dias",
      weeks: "Semanas",
    },
  },
};

export const tileFormDe = {
  [pageNameKey]: {
    id: "ID",
    title: "Titel",
    chooseTileTitle: "Wähle einen Titel für die Kachel",
    position: "Position",
    chooseTilePosition: "Wähle eine Position für die Kachel",
    grid_area: "Rasterbereich",
    chooseTileGridArea:
      "Wähle einen Rasterbereich für die Kachel: quarter|third|half|full",
    frequency: "Frequenz für Aggregation",
    time_period_amount: "Zeitraum Menge",
    chooseTileTimePeriodAmount:
      "Wähle eine Zeitraum Menge für die Kachel: 0 - 100",
    time_period_time_unit: "Zeiteinheit des Zeitraums",
    chooseTileTimePeriodTimeUnit:
      "Wähle eine Zeiteinheit des Zeitraums für die Kachel: seconds|minutes|hours|days|weeks",
    create: "Erstellen",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    checkbox: "Aggregierte Daten für einzelnen Knoten abrufen",
    gridAreaLabels: {
      quarter: "Viertel",
      third: "Drittel",
      half: "Halb",
      full: "Voll",
    },
    frequencyLabels: {
      quarterhourly: "Viertelstündlich",
      hourly: "Stündlich",
      daily: "Täglich",
      weekly: "Wöchentlich",
      monthly: "Monatlich",
      yearly: "Jährlich",
    },
    timePeriodLabels: {
      seconds: "Sekunden",
      minutes: "Minuten",
      hours: "Stunden",
      days: "Tage",
      weeks: "Wochen",
    },
  },
};

export const tileFormZhHans = {
  [pageNameKey]: {
    id: "ID",
    title: "标题",
    chooseTileTitle: "选择一个瓷砖标题",
    position: "位置",
    chooseTilePosition: "选择一个瓷砖位置",
    grid_area: "网格区域",
    chooseTileGridArea: "选择一个瓷砖网格区域: quarter|third|half|full",
    frequency: "聚合频率",
    time_period_amount: "时间段数量",
    chooseTileTimePeriodAmount: "选择一个瓷砖时间段数量: 0 - 100",
    time_period_time_unit: "时间段时间单位",
    chooseTileTimePeriodTimeUnit:
      "选择一个瓷砖时间段时间单位: seconds|minutes|hours|days|weeks",
    create: "创建",
    update: "更新",
    cancel: "取消",
    checkbox: "获取单个节点的聚合数据",
    gridAreaLabels: {
      quarter: "四分之一",
      third: "三分之一",
      half: "一半",
      full: "全部",
    },
    frequencyLabels: {
      quarterhourly: "每季度",
      hourly: "每小时",
      daily: "每日",
      weekly: "每周",
      monthly: "每月",
      yearly: "每年",
    },
    timePeriodLabels: {
      seconds: "秒",
      minutes: "分钟",
      hours: "小时",
      days: "天",
      weeks: "周",
    },
  },
};

export const tileFormIt = {
  [pageNameKey]: {
    id: "ID",
    title: "Titolo",
    chooseTileTitle: "Scegli un titolo della scheda",
    position: "Posizione",
    chooseTilePosition: "Seleziona una posizione della scheda",
    grid_area: "Area occupata sulla griglia",
    chooseTileGridArea:
      "Scegli un'area della griglia della scheda: quarter|third|half|full",
    frequency: "Frequenza di aggregazione",
    time_period_amount: "Periodo di tempo",
    chooseTileTimePeriodAmount: "Scegli un periodo temporale: 0 - 100",
    time_period_time_unit: "Unità di tempo",
    chooseTileTimePeriodTimeUnit:
      "Scegli un'unità di tempo: secondi|minuti|ore|giorni|settimane",
    create: "Crea",
    update: "Aggiorna",
    cancel: "Annulla",
    checkbox: "Raccogli dati aggregati per un singolo nodo",
    gridAreaLabels: {
      quarter: "Trimestre",
      third: "Terzo",
      half: "Mezzo",
      full: "Completo",
    },
    frequencyLabels: {
      quarterhourly: "Ogni quarto d'ora",
      hourly: "Orario",
      daily: "Quotidiano",
      weekly: "Settimanale",
      monthly: "Mensile",
      yearly: "Annualmente",
    },
    timePeriodLabels: {
      seconds: "Secondi",
      minutes: "Minuti",
      hours: "Ore",
      days: "Giorni",
      weeks: "Settimane",
    },
  },
};

export const tileFormEs = {
  [pageNameKey]: {
    id: "ID",
    title: "Título",
    chooseTileTitle: "Elige un título para el mosaico",
    position: "Posición",
    chooseTilePosition: "Elige una posición de mosaico",
    grid_area: "Área de la cuadrícula",
    chooseTileGridArea:
      "Elige un área de cuadrícula de mosaicos: cuarto|tercio|mitad|completo",
    frequency: "Frecuencia de agregación",
    time_period_amount: "Importe del período de tiempo",
    chooseTileTimePeriodAmount:
      "Elige una cantidad del período de tiempo del mosaico: 0 - 100",
    time_period_time_unit: "Período de tiempo Unidad de tiempo",
    chooseTileTimePeriodTimeUnit:
      "Elige una unidad de tiempo del período de tiempo del mosaico: segundos|minutos|horas|días|semanas",
    create: "Crear",
    update: "Actualizar",
    cancel: "Cancelar",
    checkbox: "Obtener datos agregados para un solo nodo",
    gridAreaLabels: {
      quarter: "Trimestre",
      third: "Tercero",
      half: "Mitad",
      full: "Completo",
    },
    frequencyLabels: {
      quarterhourly: "Cada quince minutos",
      hourly: "Por hora",
      daily: "Diario",
      weekly: "Semanal",
      monthly: "Mensual",
      yearly: "Anual",
    },
    timePeriodLabels: {
      seconds: "Segundos",
      minutes: "Minutos",
      hours: "Horas",
      days: "Días",
      weeks: "Semanas",
    },
  },
};

export const tileFormNl = {
  [pageNameKey]: {
    cancel: "Annuleren",
    checkbox: "Geaggregeerde gegevens ophalen voor één node",
    chooseTileGridArea:
      "Kies een tegelrastergebied: kwart|derde|helft|volledig",
    chooseTilePosition: "Kies een tegelpositie",
    chooseTileTimePeriodAmount: "Kies een aantal tegeltijdsperioden: 0 - 100",
    chooseTileTimePeriodTimeUnit:
      "Kies een tijdseenheid voor de tegeltijdsperiode: seconden|minuten|uren|dagen|weken",
    chooseTileTitle: "Kies een tegeltitel",
    create: "Aanmaken",
    frequency: "Frequentie voor aggregatie",
    frequencyLabels: {
      quarterhourly: "Per kwartier",
      hourly: "Per uur",
      daily: "Dagelijks",
      weekly: "Wekelijks",
      monthly: "Maandelijks",
      yearly: "Jaarlijks",
    },
    gridAreaLabels: {
      quarter: "Kwart",
      third: "Derde",
      half: "Helft",
      full: "Volledig",
    },
    grid_area: "Rastergebied",
    id: "ID",
    position: "Positie",
    timePeriodLabels: {
      seconds: "Seconden",
      minutes: "Minuten",
      hours: "Uren",
      days: "Dagen",
      weeks: "Weken",
    },
    time_period_amount: "Aantal tijdsperioden",
    time_period_time_unit: "Tijdseenheid tijdsperiode",
    title: "Titel",
    update: "bewerken",
  },
};

export const tileFormTr = {
  [pageNameKey]: {
    cancel: "İptal etmek",
    checkbox: "Tek düğüm için toplu verileri getir",
    chooseTileGridArea:
      "Bir döşeme ızgara alanı seçin: çeyrek|üçüncü|yarım|tam",
    chooseTilePosition: "Bir döşeme konumu seçin",
    chooseTileTimePeriodAmount:
      "Bir döşeme zaman aralığı miktarını seçin: 0 - 100",
    chooseTileTimePeriodTimeUnit:
      "Bir kutucuk zaman dilimi zaman birimi seçin: saniye|dakika|saat|gün|hafta",
    chooseTileTitle: "Bir döşeme başlığı seçin",
    create: "Yaratmak",
    frequencyLabels: {
      daily: "Günlük",
      hourly: "Saatlik",
      monthly: "Aylık",
      quarterhourly: "Çeyrek Saatlik",
      weekly: "Haftalık",
      yearly: "Yıllık",
    },
    timePeriodLabels: {
      days: "Günler",
      hours: "Saat",
      minutes: "dakika",
      seconds: "Saniye",
      weeks: "Haftalar",
    },
    frequency: "Toplama sıklığı",
    gridAreaLabels: {
      full: "Tam dolu",
      half: "Yarım",
      quarter: "Çeyrek",
      third: "Üçüncü",
    },
    grid_area: "Izgara Alanı",
    id: "İD",
    position: "Konum",
    time_period_amount: "Dönem Tutarı",
    time_period_time_unit: "Zaman Aralığı Zaman Birimi",
    title: "Başlık",
    update: "Güncelleme",
  },
};
